import { StructuredDataDisplay } from '@repo/shared/dtos/structured-data'
import { generateId } from '@repo/shared/uuid/uuid'
import { SetStateAction } from 'react'
import { toast } from 'sonner'

import { SectionCreator } from '@/components/admin/structure-data/display/SectionCreator'
import { ResetAndUpdate } from '@/components/ResetAndUpdate'
import { adminStoreActions } from '@/store/actions'
import { useStoreDispatch } from '@/store/hooks'

export function Menu({
  disabled,
  onReset,
  setUpdatedDisplay,
  updatedDisplay,
}: {
  disabled: boolean
  onReset: () => void
  setUpdatedDisplay: (value: SetStateAction<StructuredDataDisplay>) => void
  updatedDisplay: StructuredDataDisplay
}) {
  const dispatch = useStoreDispatch()
  const handleCreateSection = (label: string): void => {
    if (updatedDisplay.map((s) => s.label).includes(label.trim())) {
      toast.error('Label already exists and must be unique')
      return
    }
    setUpdatedDisplay((prev) => {
      const updatedDisplay = [...prev, { label, id: generateId(), structuredDataIds: [] }]
      return updatedDisplay
    })
  }

  const handleUpdate = (): void => {
    if (disabled) return
    void dispatch(adminStoreActions.organization.updateStructuredDataDisplay({ updatedDisplay }))
  }

  return (
    <div className="absolute right-4 top-0 flex flex-shrink-0 flex-row items-center justify-end gap-2">
      <SectionCreator onCreate={handleCreateSection} />
      <ResetAndUpdate disabled={disabled} onReset={onReset} onUpdate={handleUpdate} />
    </div>
  )
}
